module.exports = __webpack_public_path__ + "img/logo.00f266bd.svg";